class ProductInfiniteScroll extends HTMLElement {
  constructor() {
    super();
    //this.init();
  }

   connectedCallback() {
    this.reInit();
    }

  reInit() {
    // this.wrapper = this.querySelector('.product-list-wrapper');
    this.wrapper = this;  // Use 'this' since the class is on the custom element itself

    this.loadMoreButton = document.getElementById('load-more-products');
    this.isLoading = false;
    this.currentPage = parseInt(this.wrapper.dataset.infiniteCurrent, 10);
    this.maxArticlesPerPage = parseInt(this.wrapper.dataset.infiniteMax, 10);
    this.totalPages = parseInt(this.wrapper.dataset.infinitePages, 10);
    this.nextUrl = this.wrapper.dataset.infiniteNext;

    // Dedup-vangnet: houd bij welke producten al getoond zijn (op het unieke `handle`-attribuut van
    // product-card). Een niet-page-stabiele sortering -- o.a. de Jedi Collection Sort-app, of gelijke
    // created_at-timestamps bij Nieuw->Oud -- kan producten over de pagina-grens laten verschuiven,
    // waardoor 'Toon meer' al eerder getoonde producten opnieuw teruggeeft. Die slaan we hieronder over.
    this.seenHandles = new Set();
    this.wrapper.querySelectorAll('product-card').forEach((card) => {
      const handle = card.getAttribute('handle');
      if (handle) this.seenHandles.add(handle);
    });

    this.updateProductCount();

    const urlHash = window.location.hash.replace('#', '');
    if (urlHash && !isNaN(urlHash) && parseInt(urlHash, 10) > 1) {
      const targetPage = parseInt(urlHash, 10);
      this.loadProductsUpToPage(targetPage);
    }

    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', this.handleLoadMoreClick.bind(this));
    }
  }

  // De klik gaat NIET rechtstreeks naar loadMoreProducts: aria-disabled maakt een <button> niet
  // onklikbaar, en reInit() hangt bij elke 'facet:updated' opnieuw een listener op dezelfde knop.
  // Zonder deze vangrail levert een dubbele klik (of dubbele listener) twee fetches op en slaat de
  // paginateller een pagina over. loadProductsUpToPage() gaat er bewust langsheen -- die roept
  // loadMoreProducts() zelf sequentieel aan en zou op deze guard blijven hangen.
  async handleLoadMoreClick() {
    if (this.isLoading) return;
    await this.loadMoreProducts();
  }

  async loadProductsUpToPage(targetPage) {
    while (this.currentPage < targetPage && this.currentPage < this.totalPages) {
      await this.loadMoreProducts(false);
    }
  }

  async loadMoreProducts(updateHash = true) {
    if (this.currentPage >= this.totalPages) {
      this.loadMoreButton.style.display = 'none';
      return;
    }

    this.currentPage++;
    this.isLoading = true;
    this.loadMoreButton.setAttribute('aria-disabled', 'true');
    // aria-busy meldt de laadstaat aan schermlezers; .is-loading doet het zichtbare deel
    // (spinner + 'Laden...'), gestyled in assets/shopmonkey.css.
    this.loadMoreButton.setAttribute('aria-busy', 'true');
    this.loadMoreButton.classList.add('is-loading');

    try {
      const response = await fetch(this.nextUrl.replace('[% page %]', this.currentPage));
      const htmlText = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const newProducts = doc.querySelectorAll('product-card');

      newProducts.forEach((article) => {
        const handle = article.getAttribute('handle');
        // Al getoond? Overslaan (dedup-vangnet, zie reInit).
        if (handle && this.seenHandles.has(handle)) return;
        if (handle) this.seenHandles.add(handle);
        this.wrapper.appendChild(article);
      });

      const newWrapper = doc.querySelector('.product-list');
      this.nextUrl = newWrapper.dataset.infiniteNext;

      if (updateHash) {
        window.location.hash = this.currentPage;
      }

      if (this.currentPage >= this.totalPages) {
        this.loadMoreButton.style.display = 'none';
      }

      this.updateProductCount();
    } catch (error) {
      console.error('Error loading more products:', error);
    } finally {
      this.isLoading = false;
      this.loadMoreButton.removeAttribute('aria-disabled');
      this.loadMoreButton.removeAttribute('aria-busy');
      this.loadMoreButton.classList.remove('is-loading');
    }
  }

  updateProductCount() {
    const productsVisible = this.wrapper.querySelectorAll('product-card').length;
    const productCountElement = document.querySelector('.product__infinite--products-viewing');
    productCountElement.textContent = `${productsVisible}`;

    if (this.totalPages === 1) {
      this.loadMoreButton.style.display = 'none';
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.loadMoreButton.getAttribute('aria-disabled')) {
        this.loadMoreProducts();
      }
    });
  }
}

// customElements.define('product-infinite-scroll', ProductInfiniteScroll);
customElements.define('product-list', ProductInfiniteScroll);


function initProductInfiniteScroll() {
  const productListEls = document.querySelectorAll('product-list');
  // console.log('test test test 1');

  productListEls.forEach((el) => {
    console.log('test test test 2');
    if (typeof el.reInit === 'function') {
      el.reInit();
      console.log('test test test 3');
    } else {
      console.warn('reInit is geen functie op', el);
    }
  });
}


document.addEventListener('facet:updated', () => {
  console.log('facet:updated ontvangen in infinite-scroll.js');

  // Herinitialiseer Infinite Scroll functionaliteit
  initProductInfiniteScroll();
});
